module.exports = __webpack_public_path__ + "static/media/Physiotherapy.9bd3d166.webp";